import React from "react";
import { Outlet } from "react-router-dom";
import { Grid } from "@tonic/shared/components/ui";
import { Stack } from "@tonic/shared/components/ui";
import { Surface } from "@tonic/shared/components/ui";
import { Container } from "@tonic/shared/components/ui";
import { MetricCard } from "@tonic/shared/components/ui";
import {
  TrendingUp,
  Users,
  ShoppingBag,
  DollarSign
} from "lucide-react";

const summaryCards = [
  {
    title: "Total Revenue",
    value: "$45,231.89",
    trend: 20.1,
    icon: DollarSign,
    description: "Compared to last month",
    details: "Total revenue from all sales channels including online and in-store purchases"
  },
  {
    title: "Active Users",
    value: "892",
    trend: 12.5,
    icon: Users,
    description: "Current online users",
    details: "Number of users currently active across all platforms"
  },
  {
    title: "Total Orders",
    value: "1,234",
    trend: 8.2,
    icon: ShoppingBag,
    description: "Orders this month",
    details: "Total number of orders processed in the current month"
  },
  {
    title: "Growth Rate",
    value: "24.5%",
    trend: -4.3,
    icon: TrendingUp,
    description: "Average monthly growth",
    details: "Month-over-month growth rate across all metrics"
  }
];

export function DashboardLayout({ children }) {
  return (
    <Surface className="min-h-screen bg-background">
      <Container className="py-6">
        <Stack space={6}>
          <Grid cols={1} mdCols={2} lgCols={4} gap={4}>
            {summaryCards.map((card, index) => (
              <MetricCard
                key={card.title}
                title={card.title}
                value={card.value}
                trend={card.trend}
                icon={card.icon}
                description={card.description}
                tooltip={card.details}
              />
            ))}
          </Grid>

          {children || <Outlet />}
        </Stack>
      </Container>
    </Surface>
  );
}